module.exports = __webpack_public_path__ + "img/logo-lincolntech-dark.7a5e5323.svg";